jQuery(function ($) {
    $("#accordion").accordion({
      heightStyle: "content",
    });
  });
  
  // Device Accordion - Memories
  jQuery(function ($) {
    var mobile_price = $(".payment-blocks .get-price-block").text();
    var outright = parseFloat(mobile_price);
    console.log(outright);
    var outrightWithTax = outright * 0.13;
  
    let credit = $(".tab-credit-price").text();
    let tab_credit = parseFloat(credit.replace("$", "")).toFixed(2);
    let minDown = $(".min-down-val").text();
    let maxDown = parseFloat($(".max-down-val").text());
  
    var value_gb;
    $("#device-information .memory-block p").each(function () {
      $(this).on("click", function () {
        if (!$(this).hasClass("memory-active")) {
          $(this).addClass("memory-active");
          $(this).removeClass("drop-shadow");
          $(this).siblings().removeClass("memory-active");
          $(this).siblings().addClass("drop-shadow");
  
          //   Change Memory on click to the selected memories
          value_gb = $(this).text();
          $("#selected-memory-value").text(value_gb);
          $(".device-size").text(value_gb);
        }
  
        //   Change Price according to Memory Selection
        let dataram = $(this).attr("data-ram");
        console.log(dataram);
  
        $("[data-ramprice]").each(function () {
          // console.log($(this).data("ramprice"));
          if ($(this).data("ramprice") == dataram) {
            $(this).removeClass("d-none");
            $(this).siblings().addClass("d-none");
  
            let ramPrice = $(".payment-blocks .get-price-block").text(
              $(this).text().replace("$", "")
            );
            let ramWithTax = (
              (parseFloat(ramPrice[0].innerText) -
                parseFloat(minDown) -
                parseFloat(tab_credit)) /
              24
            ).toFixed(2);
  
            $(".put-price-back-block").text("$" + ramWithTax);
          }
        });
      });
    });
  
    //   Modal Open/Close
    $("#device-information .description-modal").on("click", function () {
      if (!$("#device-information .modal-container").hasClass("active")) {
        $("#device-information .modal-container").toggleClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $(".modal-container .modal-data i").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    //   Continue Button
    //   $(".open-next-accordion").on("click", function () {
    //     $(".accordion-item").each(function(){
    //         $(".accordion-item")
    //     })
    //   });
  
    //   Select Color and Change Image Accordingly
    var color_id;
    $(".outline-green").each(function () {
      $(this).on("click", function () {
        color_id = $(this).attr("data-colorid");
        $(this).addClass("active-outline");
        $(this).siblings().removeClass("active-outline");
  
        $(".mobile-image-color").each(function () {
          $(".mobile-image-color").addClass("d-none");
          $("#" + color_id).removeClass("d-none");
        });
  
        // Dynamic Color Name Text Change
        $color_name = $(this).children("p")[0].innerHTML;
        $(".change-color").text($color_name);
        $(".device-color").text($color_name);
      });
    });
  
    //   ------------------- Select Plan - Accordion ---------------------
    $(".accordion-item:last-child").addClass("d-none");
  
    $("#mobile--accordion  .tab-content .tab-pane .sub-promotion-block").each(
      function () {
        // On Click
        $(this).on("click", function () {
          $(".accordion-item:last-child").removeClass("d-none");
  
          $("#mobile--accordion  .tab-content .tab-pane").each(function () {
            $("#mobile--accordion  .tab-content .tab-pane")
              .find(".sub-promotion-block")
              .not(this)
              .removeClass("active");
          });
  
          if (!$(this).hasClass("active")) {
            $(this).addClass("active");
          }
  
          // get the price
          let plan_price = $(this).find(".price-block").children()[0].innerHTML;
          let removeDollarsign = parseInt(plan_price.replace("$", ""));
          // console.log(removeDollarsign);
  
          // get the decimal value
          let plan_decimal =
            $(this).find(".decimal-block ")[0].childNodes[1].innerHTML;
          // console.log(plan_decimal);
  
          // concated Price and decimal
          let finalPlanPrice = parseFloat(
            removeDollarsign + "." + plan_decimal
          ).toFixed(2);
          let planTax = parseFloat(finalPlanPrice) * 0.13;
          console.log(planTax);
          let finalPlanPriceWithTax = (
            parseFloat(finalPlanPrice) + planTax
          ).toFixed(2);
  
          // Paying Full Amount
          if ($("#amount-checked").data("clicked")) {
            //Plan Tax Put in Summary
            $(".total-summary-month").text(
              "$" + finalPlanPriceWithTax + " per month"
            );
            // Plan Tax in Summary
            $(".tax-summary-month").text("$" + planTax.toFixed(2) + " per month");
  
            // Tax on Total Amount put back in summary
            $(".tax-summary-tax").text(
              "$" + (outright * 0.13).toFixed(2) + " Now"
            );
          }
  
          // Put Price in Header
          $(".choose-plan-header-text").text("$" + finalPlanPrice + " unlimited");
  
          // Grab the services of plan
          let services = $(this).find(".promo-service-list-block")[0].children[0]
            .innerText;
  
          var str = nl2br(services);
  
          // Services
          $(".service-block-header").removeClass("d-none");
          $(".service-block-header").html(str);
        });
      }
    );
  
    //   ------------------- Select Plan - Accordion Ends ----------------
  
    //   --------------------- Choose Payment Option ----------------------------
  
    //   If clients want to pay full price
    $("#amount-checked").on("click", function () {
      $(this).data("clicked", true);
      //   Disable installment Input Tag
      $(".form-control").val(" ").prop("disabled", true);
      // Unhide Summary Accordion Body
      // $("#summary-accordion").removeClass("d-none");
  
      // Hide Tab Credit
      $(".tab-credit").addClass("d-none");
  
      // $(".put-price-back-block").text("$0.00");
  
      // Accordion Header Text
      if ($(".pay-full-amout-header-text").hasClass("d-none")) {
        $(".pay-full-amout-header-text").removeClass("d-none");
      }
  
      // Add Outright with tax [ TOTAL BLOCK ]
      $(".total-summary-tax").text("$" + (outright + outrightWithTax) + " Now");
    });
  
    //   <<<<---------------Installments - Downpayment checked -------->>>>>
  
    //   on Page Load - default TAX | TOTAL SUMMARY
  
    if ($("#emi-checked").next().is(":empty")) {
      // $("#summary-accordion").removeClass("d-none");
      //   Hide Pay full price text from header
      $(".pay-full-amout-header-text").addClass("d-none");
      // Minimum Downn
  
      let minDownDefault = $("#emi-sub-block .form-control").val(minDown);
      // Outright - minDown - Tab_credit / 24
      let monthlyDown = (
        (outright - parseFloat(minDown) - parseFloat(tab_credit)) /
        24
      ).toFixed(2);
  
      $(".put-price-back-block").text("$" + monthlyDown);
    }
  
    //   Down On Click
    $("#emi-checked").on("click", function () {
      $("#amount-checked").data("clicked", false);
      // $("#summary-accordion").removeClass("d-none");
      //   Hide Pay full price text from header
      $(".pay-full-amout-header-text").addClass("d-none");
      $(".form-control").prop("disabled", false).val(minDown);
    });
  
    //  When User Types - on key up
    $("#emi-sub-block .form-control").on("keyup", function () {
      // if (
      //   entertedDownPayment < parseFloat(minDown) &&
      //   !entertedDownPayment > parseFloat(maxDown)
      // ) {
      //   $("#summary-accordion").removeClass("d-none");
      // }
  
      let entertedDownPayment = parseFloat($(this).val());
      console.log(typeof entertedDownPayment);
  
      let installmentsPerMon = (
        (outright - tab_credit - entertedDownPayment) /
        24
      ).toFixed(2);
  
      if (entertedDownPayment < minDown || entertedDownPayment > maxDown) {
        //   $("#summary-accordion").addClass("d-none");
        $(".put-price-back-block").addClass("d-none");
        $(".per-month-text").html(
          "Minimum Downpayment: $" +
            minDown +
            "<br/>" +
            "Maximum Downpayment: $" +
            maxDown
        );
      } else {
        $(".per-month-text").text(" / mo. for 24 months");
        $(".put-price-back-block")
          .removeClass("d-none")
          .text("$" + installmentsPerMon);
      }
  
      // if (entertedDownPayment < parseFloat(minDown)) {
      //   $(".put-price-back-block").addClass("d-none");
      //   $(".per-month-text").text("Minimum Down Payyment: $" + minDown);
      // }
    });
  
    //   --------------------- Choose Payment Option Done ----------------------------
  });
  
  // Function to put price in tax summary
  // function taxSummary(planWithTax) {
  //   // Put plan price in TOTAL SUMMARY ACCORDION
  //   $(".total-summary-month").text("$" + PlanWithTax + " per month");
  // }
  
  function nl2br(services, is_xhtml) {
    var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "";
    return (services + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, breakTag);
  }
  